module.exports = __webpack_public_path__ + "img/download2.33f95b78.png";